import { useEffect, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";
import ProfitCostTemplateList from "./FixedHeaderList";
import styles from "../Settings.module.scss";
import EditFixedFeeHeader from "./EditFixedFeeHeader";
import { addFixedFeeHeader } from "services/fixedfeeService";

const ProfitCostTemplate = ({ onClose, open }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeForm = () => {
    setIsFormOpen(false);
  };

  useEffect(() => {
    if (onClose === false) {
      closeForm();
    }
  }, [onClose]);

  const handleSubmit = async (formData) => {
    setIsSubmitting(true);
    try {
      // Ensure allowedApps is properly formatted and filter out any empty values
      const allowedApps = Array.isArray(formData.allowedApps)
        ? formData.allowedApps.filter(Boolean).join(",")
        : formData.allowedApps;

      const res = await addFixedFeeHeader({
        ...formData,
        allowedApps,
        type: "ProfitCost",
      });
      if (res.success) {
        toast.success("Template added successfully");
        closeForm();
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex ms-auto mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={() => {
            setIsFormOpen(true);
            open?.();
          }}
        >
          Add Template
        </Button>
      </div>

      <div className="flex-grow-1 mb-2" style={{ minHeight: 0 }}>
        <ProfitCostTemplateList />
      </div>

      {isFormOpen && (
        <EditFixedFeeHeader
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default ProfitCostTemplate;
